/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Scope_BodyInputs */

const en_svc_agents_scope_body = /** @type {(inputs: Svc_Agents_Scope_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An AI agent is software that reads a situation, chooses the next step from rules you agree, and uses connected tools to prepare it. We keep each agent narrow, so it stays predictable and easy to check.`)
};

const lv_svc_agents_scope_body = /** @type {(inputs: Svc_Agents_Scope_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI aģents ir programmatūra, kas izvērtē situāciju, izvēlas nākamo soli pēc saskaņotiem noteikumiem un sagatavo to, izmantojot savienotos rīkus. Katram aģentam nosakām konkrētu uzdevumu, lai tā darbība būtu paredzama un viegli pārbaudāma.`)
};

/**
* | output |
* | --- |
* | "An AI agent is software that reads a situation, chooses the next step from rules you agree, and uses connected tools to prepare it. We keep each agent narrow..." |
*
* @param {Svc_Agents_Scope_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_scope_body = /** @type {((inputs?: Svc_Agents_Scope_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Scope_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_scope_body(inputs)
	return en_svc_agents_scope_body(inputs)
});